import type { HeroCarouselItemStyleProps } from '../hero-carousel'

export * from './constants'

export const getClassNameByContentConfiguration = (
  baseClassName: string,
  configuration?: {
    alignContentHorizontally: string
  }
) => {
  const className = `${baseClassName} ${baseClassName}__content--${
    configuration?.alignContentHorizontally ?? 'horizontal-align-center'
  }`

  return className
}

export const isContentCenterAligned = (alignment: string) => {
  return alignment === 'horizontal-align-center'
}

export const getCustomStyles = (styles?: HeroCarouselItemStyleProps) => {
  let styleObject = {}

  for (const prop in styles) {
    if (styles[prop]) {
      styleObject = { ...styleObject, [prop]: styles[prop] }
    }
  }

  return styleObject
}
